/* eslint-disable max-len */
import {
    GenericResourceResponse, ResourceResponse
} from '../types/resource.types';

export const UNKNOWN_ERROR_MESSAGE = 'Unknown error';

// TODO: this is just a workaround would be better solved in 3p-resource
const tryParseResponseError = (response: any): {
    code?: string,
    message: string
} | null => {
    try {
        const rawJSON = JSON.parse(response?.verb?.request?.responseText);
        if (typeof rawJSON?.message === 'string' || typeof rawJSON?.code !== 'undefined') {
            return rawJSON;
        }
    } catch {
    }

    return null;
};

// Attempt to determine the error message from the backend
// There are some Error types seen that are not provided from 3p-resource,
// Eg a 500 with:
// { code: 'Communication', message: 'The server did not provide a meaningful reply' }
const resolveErrorMessage = (
    response: ResourceResponse,
    fallbackMessage?: string
): string => {
    if ('message' in response) {
        if (typeof response.message === 'string') {
            return response.message;
        }
    }

    if ('title' in response) {
        const messages = Array.isArray(response.errors) && response.errors.length > 0 ?
            response.errors.join('\n ') : '';
        const message = response.title || UNKNOWN_ERROR_MESSAGE;
        return `
${message}
${messages}
`;
    }

    const responseError = tryParseResponseError(response);
    if (responseError?.message) {
        return responseError.message;
    }

    if (responseError?.code) {
        return responseError.code;
    }

    return fallbackMessage || UNKNOWN_ERROR_MESSAGE;
};

export class ResourceResponseError extends Error {
    readonly response: ResourceResponse;

    constructor (response: ResourceResponse) {
        super();
        Error.captureStackTrace(this, this.constructor);
        this.name = 'ResourceResponseError';
        this.message = resolveErrorMessage(response);
        this.response = response;
    }
}

export const isResourceResponseError = (error: any): error is ResourceResponseError => {
    return (error?.name === 'ResourceResponseError' && error?.response);
};

export const isNotFoundError = (error: any) => {
    if (isResourceResponseError(error)) {
        return 'status' in error.response && error.response?.status === 404;
    }
    return false;
};

export const resolveResponseData = <T = {}> (response: ResourceResponse<T>): T => {
    if ('status' in response && response?.status === 200) {
        return (<GenericResourceResponse<T>>response).data;
    }

    throw new ResourceResponseError(response);
};

export const resolveResourceResponseErrorMessage = (
    error: any,
    fallbackMessage?: string
): string | null => {
    return resolveErrorMessage(error?.response, fallbackMessage);
};
